import l from "react";
import { getIconColor as r } from "./iconfont.es5470.js";
import f from "./iconfont.es5471.js";
const d = {
  display: "block"
}, h = ({ size: a = 16, useVw: e, useRem: t, color: n, withColor: i, removeClassName: o, disableSSR: m, style: c, ...p }) => {
  const x = c ? { ...d, ...c } : d;
  return /* @__PURE__ */ l.createElement(f, { disableSSR: m }, /* @__PURE__ */ l.createElement("svg", { "data-icon-id": "32px-xianhuojiaoyi", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 32 32", width: e ? ((a || 0) / 375 * 100).toFixed(5) + "vw" : a + (t ? "rem" : "px"), height: e ? ((a || 0) / 375 * 100).toFixed(5) + "vw" : a + (t ? "rem" : "px"), className: o ? "" : "iconpark-icon", style: x, fill: "none", ...p }, /* @__PURE__ */ l.createElement(
    "g",
    {
      className: o ? "" : "32px-ç°è´§äº¤æ"
    },
    /* @__PURE__ */ l.createElement(
      "path",
      {
        clipRule: "evenodd",
        className: o ? "" : "normal",
        d: "M5.7 16c0-5.69 4.613-10.3 10.3-10.3 5.689 0 10.3 4.611 10.3 10.3a.9.9 0 1 0 1.8 0c0-6.683-5.417-12.1-12.1-12.1C9.318 3.9 3.9 9.317 3.9 16S9.319 28.1 16 28.1a.9.9 0 1 0 0-1.8c-5.688 0-10.3-4.611-10.3-10.3Zm12.494-4.498a.9.9 0 0 0-1.691-.616l-.17.467-1.378-.501a1.328 1.328 0 0 0-1.702.793l-.74 2.035-.003-.001-1.356 3.726c-.251.69.104 1.451.793 1.702l1.378.502-.17.467a.9.9 0 0 0 1.692.616l.17-.468.795.29a2.646 2.646 0 0 0 3.372-3.446 2.647 2.647 0 0 0-.364-4.81l-.796-.289.17-.467Zm-.572 4.038.013.005a.846.846 0 0 0 .569-1.595l-3.421-1.245-.58 1.59 3.42 1.245Zm-4.615 2.037.579-1.59 3.423 1.245.009.003a.847.847 0 0 1-.59 1.587l-3.421-1.245Zm11.574 1.46a.9.9 0 0 1 1.271.059l2.013 2.206a.9.9 0 0 1-.665 1.507H20a.9.9 0 0 1 0-1.8h5.16l-.637-.7a.9.9 0 0 1 .058-1.272Zm-1.996 8.806a.9.9 0 0 1-1.27-.068L19.33 25.57a.9.9 0 0 1 .67-1.502h7.167a.9.9 0 0 1 0 1.8H22.02l.634.705a.9.9 0 0 1-.068 1.27Z",
        fillRule: "evenodd",
        fill: i ? r(n, 0, "#262933") : "#262933",
        datafollowfill: i ? r(n, 0, "#262933") : "#262933"
      }
    )
  )));
}, E = h;
export {
  E as default
};
